import { PropsWithChildren, ReactElement } from "react"
import { makeStyles } from "tss-react/mui"
import { Stack, Typography } from "@mui/material"

const useStyles = makeStyles()((theme) => ({
    container: {
        color: theme.palette.text.primary,
    },
    box: {
        padding: "1rem",
        background: theme.palette.tailwind.slate[50],
    },
}))
type OrderSummaryItemBoxProps = Readonly<
    PropsWithChildren<{
        title: ReactElement
        titleDetails?: string | null
    }>
>

export function OrderSummaryItemBox({ title, titleDetails, children }: OrderSummaryItemBoxProps) {
    const { classes } = useStyles()

    return (
        <Stack gap=".5rem" className={classes.container}>
            <Stack direction="row" gap=".5rem" alignItems="center" justifyContent="space-between">
                <Typography variant="body1">{title}</Typography>
                {titleDetails && <Typography variant="subtitle1">{titleDetails}</Typography>}
            </Stack>

            <Stack gap="1rem" className={classes.box}>
                {children}
            </Stack>
        </Stack>
    )
}
